import type { Room } from 'matrix-js-sdk';
import { useSyncExternalStore } from 'react';
import { roomsStore } from '../stores/RoomsStore';

/**
 * Hook zum Abrufen aller Matrix Rooms.
 * Reaktiv - löst Re-Renders aus, wenn Rooms hinzugefügt oder entfernt werden.
 *
 * @returns Array von Room-Objekten
 */
export function useRooms(): Room[] {
  return useSyncExternalStore(roomsStore.subscribe, roomsStore.getSnapshot);
}
